import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendWelfareBenefits } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendWelfareBenefitsState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendWelfareBenefitsInitialState: JobRecommendListForTrendWelfareBenefitsState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendWelfareBenefitsSlice = createSlice({
  name: 'jobRecommendListForTrendWelfareBenefits',
  initialState: jobRecommendListForTrendWelfareBenefitsInitialState,
  reducers: {
    setInitialDisplayFlagWelfareBenefits: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendWelfareBenefits.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getJobListForTrendWelfareBenefits.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(getJobListForTrendWelfareBenefits.rejected, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Create Action
export const { setInitialDisplayFlagWelfareBenefits } =
  jobRecommendListForTrendWelfareBenefitsSlice.actions;

// reducer
export const jobRecommendListForTrendWelfareBenefitsReducer =
  jobRecommendListForTrendWelfareBenefitsSlice.reducer;

interface State {
  jobRecommendListForTrendWelfareBenefits: JobRecommendListForTrendWelfareBenefitsState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendWelfareBenefitsLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendWelfareBenefits?.jobRecommendListForTrend
    .loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendWelfareBenefitsEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendWelfareBenefits?.jobRecommendListForTrend
    .entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagWelfareBenefitsSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendWelfareBenefits.initialDisplayFlag;
